module.exports = __webpack_public_path__ + "static/media/500.192d8f70.jpg";